import { __awaiter, __generator } from "tslib";
import { resolveConfig } from '@office-start/config-resolver-service';
import { getErrorHandler } from '@office-start/error-handler';
import { fetchFeatureSettings, getFeatureSettings, } from '@office-start/feature-settings-service';
var masterCollection;
// Add keys that should not be fetched from server
var skipServerFetchKeysCollection = [];
// TODO: Figure out how to get first visit when storage dump is not in page response
var firstUse;
var firstUseTimestamp;
var initialized = false;
var skipFetchInitialized = false;
var notFoundInServer = {};
function ensureInitialized() {
    return __awaiter(this, void 0, void 0, function () {
        var cache, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (initialized) {
                        return [2 /*return*/];
                    }
                    initialized = true;
                    cache = undefined;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, resolveConfig('userStorageCache')];
                case 2:
                    cache = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    getErrorHandler().handleError(error_1);
                    return [3 /*break*/, 4];
                case 4:
                    masterCollection = cache ? cache.content : {};
                    firstUse = cache ? cache.firstUse : false;
                    firstUseTimestamp = cache ? cache.firstUseTimestamp : 0;
                    notFoundInServer = {};
                    return [2 /*return*/];
            }
        });
    });
}
function ensureSkipFetchInitialized() {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var featureSettingsResult, featureSettings, _c, serverFetchKeys;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (skipFetchInitialized) {
                        return [2 /*return*/];
                    }
                    featureSettingsResult = getFeatureSettings();
                    if (!(featureSettingsResult === null || featureSettingsResult === void 0 ? void 0 : featureSettingsResult.result)) return [3 /*break*/, 1];
                    _c = featureSettingsResult;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, fetchFeatureSettings()];
                case 2:
                    _c = _d.sent();
                    _d.label = 3;
                case 3:
                    featureSettings = _c;
                    skipFetchInitialized = true;
                    serverFetchKeys = (_b = (_a = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.result) === null || _a === void 0 ? void 0 : _a.copilot) === null || _b === void 0 ? void 0 : _b.skipServerFetchKeys;
                    if (serverFetchKeys) {
                        skipServerFetchKeysCollection = serverFetchKeys.split(',');
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function getMasterCollection() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ensureInitialized()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, masterCollection];
            }
        });
    });
}
export function getSkipServerFetchKeysCollection() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ensureSkipFetchInitialized()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, skipServerFetchKeysCollection];
            }
        });
    });
}
export function isFirstUse() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ensureInitialized()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, firstUse];
            }
        });
    });
}
// TODO: handle in user-profile service as that's the document this belongs to
export function getFirstUseTimestamp() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ensureInitialized()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, firstUseTimestamp];
            }
        });
    });
}
export function setNotFoundInServer(key, value) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ensureInitialized()];
                case 1:
                    _a.sent();
                    notFoundInServer[key] = value;
                    return [2 /*return*/];
            }
        });
    });
}
export function getNotFoundInServer(key) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ensureInitialized()];
                case 1:
                    _a.sent();
                    if (key in notFoundInServer) {
                        return [2 /*return*/, notFoundInServer[key]];
                    }
                    else {
                        return [2 /*return*/, undefined];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=UserStorageService.js.map